import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import React, { Component } from 'react';
import { Card, CardHeader, CardBody, Container, Row, Col, Button} from 'reactstrap';
import CollectionForm from './components/CollectionForm';
import { withTranslation } from 'react-i18next';
import { createOrUpdateCollection } from "../../../redux/actions/collections";
import { loadAssetTypes, loadProcessTypes } from "../../../redux/actions/entity_types";

class CollectionCreateUpdate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formType: "clone"
        };
        this.handleCreate = this.handleCreate.bind(this);
        this.closeForm = this.closeForm.bind(this);
        this.build_type_lists = this.build_type_lists.bind(this);
    }

    componentWillMount() {
        console.log("Mounting selected collection component");
        this.props.loadAssetTypes();
        this.props.loadProcessTypes();
    }

    handleCreate(data){
        console.log("handleCreate");
        console.log(data);
        const { createOrUpdateCollection, history} = this.props;
        if (data.collection_purpose=='PROCESS_MONITORING'){
            let process_types =[]
            for (let j = 0; j < data.process_type_params.length; j++) {
                 if (data.process_type_params[j].value){
                   delete data.process_type_params[j].value
                   process_types.push(data.process_type_params[j])
                 }
            }
            data.process_type_list = process_types
            delete data.process_type_params;
            delete data.asset_type_params;
        } else{
            let asset_types =[]
            for (let j = 0; j < data.asset_type_params.length; j++) {
                 if (data.asset_type_params[j].value){
                   asset_types.push(data.asset_type_params[j])
                 }
            }
            data.asset_type_list = asset_types
            delete data.process_type_params;
            delete data.asset_type_params;
        }
        delete data.formType;
        data.collection_type = data.collection_type.value
        data.collection_purpose = data.collection_purpose.value
        console.log("Cleaned collection data");
        console.log(data);
        createOrUpdateCollection(data);
        history.push("/settings/collection_settings");
    }

    closeForm = () => {
        this.props.history.push("/settings/collection_settings");
    };

    build_type_lists(selected_collection, asset_types, process_types){
        let asset_type_params =[]
        if (asset_types){
            for (let i = 0; i < asset_types.length; i++) {
                let atype = {name:asset_types[i].name, value:false, _id:asset_types[i]._id};
                asset_type_params.push(atype);
            }
            if (selected_collection && selected_collection.asset_type_list){
                for (let i = 0; i < selected_collection.asset_type_list.length; i++) {
                      for (let j = 0; j < asset_type_params.length; j++) {
                          if (selected_collection.asset_type_list[i]._id == asset_type_params[j]._id){
                            asset_type_params[j].value=true;
                            break;
                          }
                      }
                }
            }
        }

        let process_type_params =[]
        if (process_types){
            for (let i = 0; i < process_types.length; i++) {
                let ptype = {name:process_types[i].name, value:false, _id:asset_types[i]._id};
                process_type_params.push(ptype);
            }
            if (selected_collection && selected_collection.process_type_list){
                for (let i = 0; i < selected_collection.process_type_list.length; i++) {
                      for (let j = 0; j < process_type_params.length; j++) {
                          if (selected_collection.process_type_list[i]._id == process_type_params[j]._id){
                            process_type_params[j].value=true;
                            break;
                          }
                      }
                }
            }
        }
        let new_selected_collection =null;
        if (!selected_collection){
            new_selected_collection = {};
            new_selected_collection["formType"]="create";
        } else{
            new_selected_collection = JSON.parse(JSON.stringify(selected_collection));
            if (selected_collection.collection_type){
                console.log(selected_collection.collection_type);
                let new_label = selected_collection.collection_type.replace(/_/g,' ');
                new_selected_collection.collection_type ={value:selected_collection.collection_type, label:new_label};
            }
            if (selected_collection.collection_purpose){
                let new_label = selected_collection.collection_purpose.replace(/_/g,' ');
                new_selected_collection.collection_purpose ={value:selected_collection.collection_purpose,
                label:new_label}
            }
            if (new_selected_collection.formType =="clone"){
                new_selected_collection._id=null;
                delete new_selected_collection._id;
                delete new_selected_collection.collection_name;
            }
        }
        new_selected_collection["asset_type_params"]= asset_type_params;
        new_selected_collection["process_type_params"]= process_type_params;

        return new_selected_collection;
    }


    render() {
        const { selected_collection, asset_types, process_types, t } = this.props;
        let new_selected_collection = this.build_type_lists(selected_collection, asset_types, process_types);
        console.log("New Selected Collection");
        console.log(new_selected_collection);
        return (
           <Container>
              <Row>
                <Col md={12}>
                    <h3 className="page-title">{t('collection_settings.create_update_collection.title')}</h3>
                    <h3 className="page-subhead subhead">{t('collection_settings.create_update_collection.sub_title')}
                    </h3>
                     <Card>
                      {new_selected_collection.formType =="update" ?
                        <CardHeader>{t('collection_settings.create_update_collection.form_update_title')}</CardHeader>
                       : <CardHeader>{t('collection_settings.create_update_collection.form_create_title')}</CardHeader>
                       }
                      <CardBody>
                        <CollectionForm
                          form_data={new_selected_collection}
                          onSubmit={this.handleCreate}
                          onCancel={() => {
                            this.closeForm();
                          }}
                        />
                      </CardBody>
                    </Card>
                </Col>
              </Row>
           </Container>
        );
    }
}

function mapStateToProps({ selected_collection, asset_types, process_types }) {
  console.log("selected collection state update");
  console.log(selected_collection);
  return { selected_collection, asset_types, process_types };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        createOrUpdateCollection,
        loadAssetTypes,
        loadProcessTypes
    }, dispatch);
}

export default withTranslation('common') (connect(mapStateToProps,mapDispatchToProps)(CollectionCreateUpdate));
